// extracted by mini-css-extract-plugin
module.exports =  {"container":"style-module_container__P4jJm1HDaUFkbW6IVVJl","name":"style-module_name__Nogk7fRleatb4LIZ0Jot","description":"style-module_description__tm_2c9XteIFDL34un99M"};